import { z } from 'zod'
import { paginatedSearchQuery } from '../zod/pagination'

export const messageTemplatePurpose = z.enum(['start', 'recontact', 'reject'])

export const messageTemplatePurposes = Object.values(messageTemplatePurpose.enum)

export type MessageTemplatePurpose = z.infer<typeof messageTemplatePurpose>

// i18n-extract:
// t('templatePurposes.start')
// t('templatePurposes.recontact')
// t('templatePurposes.reject')
// t('templateStatuses.APPROVED')
// t('templateStatuses.REJECTED')
// t('templateStatuses.PENDING')

export const messageTemplate = z.object({
    id: z.string(),
    whatsappBusinessAccountId: z.string(),
    metaTemplateId: z.string().nullable().optional(),
    title: z.string(),
    name: z.string(),
    purpose: messageTemplatePurpose,
    body: z.string(),
    language: z.string(),
    category: z.enum(['AUTHENTICATION', 'MARKETING', 'UTILITY']),
    status: z.enum(['PENDING', 'APPROVED', 'REJECTED']),
    public: z.boolean(),
    rejectionReason: z.string().nullable().optional(),
    submittedAt: z.coerce.date().nullable().optional(),
    approvedAt: z.coerce.date().nullable().optional(),
    rejectedAt: z.coerce.date().nullable().optional(),
    lastSyncedAt: z.coerce.date().nullable().optional(),
    createdAt: z.coerce.date().nullable().optional(),
    updatedAt: z.coerce.date().nullable().optional(),
})

export type MessageTemplate = z.infer<typeof messageTemplate>

export const messageTemplateQuery = paginatedSearchQuery({
    filters: z.object({
        title: z.string().array().optional(),
        purpose: messageTemplatePurpose.array().optional(),
        status: z.enum(['PENDING', 'APPROVED', 'REJECTED']).array().optional(),
        public: z.enum(['true', 'false']).array().optional(),
        whatsappBusinessAccountId: z.string().array().optional(),
    }),
    sort: z.enum([
        'title',
        '-title',
        'purpose',
        '-purpose',
        'status',
        '-status',
        'created_at',
        '-created_at',
        'updated_at',
        '-updated_at',
    ]),
})

export type MessageTemplateQuery = z.infer<typeof messageTemplateQuery>
